import getTypeOfAttachment from './getTypeOfAttachment';
import AttachmentClass from '../store/schema/AttachmentClass';
import AttachmentModel, { ReferenceAttachmentModel } from '../store/schema/AttachmentModel';
import TypeOfAttachment from '../store/schema/TypeOfAttachment';
import { ClientAttachmentId } from 'owa-client-ids';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import ReferenceAttachment from 'owa-service/lib/contract/ReferenceAttachment';

export default function createAttachmentModel(
    attachmentId: ClientAttachmentId,
    attachment: AttachmentType
): AttachmentModel {
    const attachmentModel: AttachmentModel = {
        id: attachmentId,
        type: getTypeOfAttachment(attachment),
        download: {
            url: null,
        },
        attachmentClass: AttachmentClass.Default,
        previewImage: {
            url: null,
        },
        thumbnailImage: {
            url: null,
        },
        info: {
            allowDownload: false,
            supportedPermissionLevels: [],
            sharingInfo: null,
        },
        model: attachment,
    };

    if (attachmentModel.type === TypeOfAttachment.Reference) {
        const referenceAttachmentModel: ReferenceAttachmentModel = {
            ...attachmentModel,
            type: TypeOfAttachment.Reference,
            openUrl: null,
            isFolder: (attachment as ReferenceAttachment).AttachmentIsFolder,
            requiresFetchingSharingInformation: false,
        };

        return referenceAttachmentModel;
    }

    return attachmentModel;
}
